const styles = theme => ({
  root: {
    height: '100%',
    overflowY: 'auto' as 'auto',
  },
})

export default styles
